export const METRICS_CONFIG = {
    FLUSH_INTERVAL: 60000
}
